<template>
  <b-media
    class="notification-card "
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
        :src="getAvatar(displayNotification.avatar)"
      >
        <feather-icon
          v-if="!displayNotification.avatar"
          :icon="displayNotification.icon"
        />
      </b-avatar>
    </template>
    <p class="media-heading d-flex align-items-center mb-0">
      <span class="font-weight-bolder">
        {{ displayNotification.title }}
      </span>
      <feather-icon
        v-if="!notification.isRead && unReadNotifications!=0"
        icon="CircleIcon"
        size="8"
        fill="#3D61AD"
        class="ml-1 text-primary"
      />
    </p>
    <small class="notification-text">{{ displayNotification.subtitle }}</small>
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import { BMedia, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BAvatar,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    displayNotification() {
      const currentUser = JSON.parse(localStorage.getItem('userData'))
      const {
        notification, creator, isRead, uuid, createdAt,
      } = this.notification
      const { user } = notification
      const displayUser = user.uuid === currentUser.uuid ? 'your' : `${user.name}'s`
      const creatorName = creator.uuid === currentUser.uuid ? 'You have' : `${creator.name} has`

      const subtitle = `${creatorName} ${notification.hours > 0 ? `changed ${displayUser} time limit to  ${notification.hours} hrs ${notification.type.toLowerCase()}.` : `removed ${displayUser} time limit`}`

      return {
        title: 'Time Limit Change!!', subtitle, type: 'light-info', icon: 'InfoIcon', avatar: creator.avatar, isRead, uuid, createdAt,
      }
    },
  },
}
</script>
